
// Diese Werte werden in die e5-Tracking-Datenbank fürs Dashboard geschrieben.
export const STATE_DISPLAY_NAMES = {
    'zipCodeQuestion': 'Frage: PLZ-Eingabe',
    'zipCodeNotAvailable': 'Abbruch: PLZ nicht verfügbar',
    'buildingTypeQuestion': 'Frage: Gebäudetyp',
    'buildingTypeNotAvailable': 'Abbruch: Gebäudetyp nicht verfügbar',
    'ownerQuestion': 'Frage: Eigentümer',
    'ownerNotAvailable': 'Abbruch: Eigentümer nicht verfügbar',
    'buildingAgeQuestion': 'Frage: Baujahr',
    'buildingAgeNotAvailable': 'Abbruch: Baujahr nicht verfügbar',
    'monumentQuestion': 'Frage: Denkmalschutz',
    'monumentNotAvailable': 'Abbruch: Denkmalschutz nicht verfügbar',
    'renovationQuestion': 'Frage: Sanierungsarbeiten',
    'renovationNotAvailable': 'Abbruch: Unsaniert nicht verfügbar',
    'heatingLocationQuestion': 'Frage: Standort der Heizung',
    'heatingLocationNotAvailable': 'Abbruch: Heizungsstandort nicht verfügbar',
    'numberPersonsQuestion': 'Frage: Anzahl Personen',
    'wishPVQuestion': 'Frage: Wunsch nach PV-Anlage',
    'appointmentTypeQuestion': 'Frage: Vor-Ort-Termin',
    'plannedReplacementQuestion': 'Frage: Geplanter Austausch',
    'contactInformationQuestion': 'Frage: Kontaktinformationen',
};

// Für diese States soll keine Fortschrittsanzeige erscheinen.
export const statesWithoutHeadline = [
    'zipCodeNotAvailable',
    'buildingTypeNotAvailable',
    'ownerNotAvailable',
    'buildingYearNotAvailable',
    'monumentNotAvailable',
    'renovationNotAvailable',
    'heatingLocationNotAvailable',
];

// Das ist die Reihenfolge der Qualifizierungsfragen. Sie wird für die Fortschrittsanzeige verwendet.
export const QUESTION_STEPS_ORDER = [
    'buildingTypeQuestion',
    'ownerQuestion',
    //'buildingAgeQuestion',
    'alreadyBuiltQuestion',
    'zipCodeQuestion',
    'monumentQuestion',
    //'renovationQuestion',
    'heatingLocationQuestion',
    'numberPersonsQuestion',
    'plannedReplacementQuestion',
    'wishPVQuestion',
    //'appointmentTypeQuestion',
    'contactInformationQuestion',
];

// Für die PostMessages ergibt sich die ScreenNumber aus der Reihenfolge der Qualifizierungsfragen
// Außerdem brauchen wir die ScreenNumber des Kontaktformulars und der Bestätigungsseite
export const QUESTION_STEPS_ORDER_FOR_MESSAGE_STATES = [
    ...QUESTION_STEPS_ORDER,
    'submissionSuccess'
];

// Die Struktur der Message für die PostMessages
const BASE_POST_MESSAGE_STATES = {
    buildingTypeQuestion: {
        screen_name: 'gebaeudeart',
        conversion: false,
        action: 'view_screen',
        route_name: 'waermepumpe_v2',
    },
    buildingTypeNotAvailable: {
        screen_name: 'absage gebaeudeart',
        conversion: false,
        action: 'view_screen',
        route_name: 'waermepumpe_v2',
    },

    zipCodeQuestion: {
        screen_name: 'plz-abfrage',
        conversion: false,
        action: 'view_screen',
        route_name: 'waermepumpe_v2',
    },
    zipCodeNotAvailable: {
        screen_name: 'absage plz-abfrage',
        conversion: false,
        action: 'view_screen',
        route_name: 'waermepumpe_v2',
    },

    ownerQuestion: {
        screen_name: 'eigentumsverhaeltnis',
        conversion: false,
        action: 'view_screen',
        route_name: 'waermepumpe_v2',
    },
    ownerNotAvailable: {
        screen_name: 'absage eigentumsverhaeltnis',
        conversion: false,
        action: 'view_screen',
        route_name: 'waermepumpe_v2',
    },
    /*
    buildingAgeQuestion: {
        screen_name: 'baujahr',
        conversion: false,
        action: 'view_screen',
        route_name: 'waermepumpe_v2',
    },
    buildingAgeNotAvailable: {
        screen_name: 'absage baujahr',
        conversion: false,
        action: 'view_screen',
        route_name: 'waermepumpe_v2',
    },*/
    alreadyBuiltQuestion: {
        screen_name: 'bauzustand',
        conversion: false,
        action: 'view_screen',
        route_name: 'waermepumpe_v2',
    },
    buildingYearNotAvailable: {
        screen_name: 'absage bauzustand',
        conversion: false,
        action: 'view_screen',
        route_name: 'waermepumpe_v2',
    },
    monumentQuestion: {
        screen_name: 'denkmalschutz',
        conversion: false,
        action: 'view_screen',
        route_name: 'waermepumpe_v2',
    },
    monumentNotAvailable: {
        screen_name: 'absage denkmalschutz',
        conversion: false,
        action: 'view_screen',
        route_name: 'waermepumpe_v2',
    },
    /*
    renovationQuestion: {
        screen_name: 'energetische sanierung',
        conversion: false,
        action: 'view_screen',
        route_name: 'waermepumpe_v2',
    },
    renovationNotAvailable: {
        screen_name: 'absage energetische sanierung',
        conversion: false,
        action: 'view_screen',
        route_name: 'waermepumpe_v2',
    },*/
    heatingLocationQuestion: {
        screen_name: 'standort heizung',
        conversion: false,
        action: 'view_screen',
        route_name: 'waermepumpe_v2',
    },
    heatingLocationNotAvailable: {
        screen_name: 'absage standort heizung',
        conversion: false,
        action: 'view_screen',
        route_name: 'waermepumpe_v2',
    },
    numberPersonsQuestion: {
        screen_name: 'anzahl personen',
        conversion: false,
        action: 'view_screen',
        route_name: 'waermepumpe_v2',
    },
    wishPVQuestion: {
        screen_name: 'wunsch pv-anlage',
        conversion: false,
        action: 'view_screen',
        route_name: 'waermepumpe_v2',
    },
    appointmentTypeQuestion: {
        screen_name: 'wunsch vor-ort-termin',
        conversion: false,
        action: 'view_screen',
        route_name: 'waermepumpe_v2',
    },
    plannedReplacementQuestion: {
        screen_name: 'zeitpunkt',
        conversion: false,
        action: 'view_screen',
        route_name: 'waermepumpe_v2',
    },
    contactInformationQuestion: {
        screen_name: 'kontaktformular',
        conversion: false,
        action: 'view_screen',
        route_name: 'waermepumpe_v2',
    },
    submissionSuccess: {
        screen_name: 'bestaetigung',
        conversion: true,
        action: 'view_screen',
        route_name: 'waermepumpe_v2',
    },
};

// POST_MESSAGE_STATES Objekt mit dynamischen screen_numbern generieren
export const POST_MESSAGE_STATES = Object.keys(BASE_POST_MESSAGE_STATES).reduce((acc, stateKey) => {
    let screenNumber = 99; // Standardwert

    // Prüfen, ob der Schlüssel in QUESTION_STEPS_ORDER_FOR_MESSAGE_STATES vorkommt
    const questionIndex = QUESTION_STEPS_ORDER_FOR_MESSAGE_STATES.indexOf(stateKey);
    if (questionIndex !== -1) {
        screenNumber = questionIndex + 1;
    }

    acc[stateKey] = {
        ...BASE_POST_MESSAGE_STATES[stateKey],
        screen_number: screenNumber,
    };
    return acc;
}, {});

